package er.prateek.crossly.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import er.prateek.crossly.di.AppContainer
import er.prateek.crossly.persistence.ThemePreferences
import er.prateek.crossly.persistence.ThemeStore

/**
 * Holds the user's chosen theme mode + color palette, backed by [ThemeStore]
 * so the choice survives a relaunch.
 */
class ThemeState(
    initialMode: ThemeMode,
    initialPaletteId: PaletteId,
    private val store: ThemeStore,
) {
    val mode: MutableState<ThemeMode> = mutableStateOf(initialMode)
    val paletteId: MutableState<PaletteId> = mutableStateOf(initialPaletteId)

    fun setMode(newMode: ThemeMode) {
        mode.value = newMode
        store.save(ThemePreferences(newMode, paletteId.value))
    }

    fun setPalette(newPaletteId: PaletteId) {
        paletteId.value = newPaletteId
        store.save(ThemePreferences(mode.value, newPaletteId))
    }
}

@Composable
fun rememberThemeState(store: ThemeStore = AppContainer.themeStore): ThemeState =
    remember {
        val preferences = store.load()
        ThemeState(preferences.mode, preferences.paletteId, store)
    }
